export default class DesignerService {
    public static getSVGCoordinates(svg: SVGSVGElement, clientX: number, clientY: number): {x: number, y: number} {
        // TODO improve the coordinates conversion as the clone is created with vertical grap from the drop point
        const point = svg.createSVGPoint()
        point.x = clientX
        point.y = clientY

        // Transform the screen point to SVG space using the transformation matrix
        const ctm = svg.getScreenCTM().inverse(); // Get the inverse of the current transformation matrix
        return point.matrixTransform(ctm); //

        // return {
        //     x: point.x,
        //     y: point.y
        // }
    }

    public static getNestedSVGCoordinates(svg: SVGSVGElement, clientX: number, clientY: number): {x: number, y: number} {
        // if (svg.ownerSVGElement)
            // debugger
        // let element = event.target;
        // let svg = element.ownerSVGElement || element;
        let svg_ = svg
        // Initialize a point with the mouse coordinates
        const point = svg_.createSVGPoint();
        point.x = clientX;
        point.y = clientY;
      
        // Accumulate transformations from nested SVGs
        let ctm = svg_.getScreenCTM().inverse();  // Start with the current SVG's inverse matrix
        svg_ = svg_.ownerSVGElement
        while (svg_ && svg_.nodeName === "svg") {
          // Multiply the current transformation matrix with the parent's if there's a nested SVG
          ctm = ctm.multiply(svg_.getScreenCTM().inverse());
          svg_ = svg_.ownerSVGElement; // Move up to the parent SVG, if nested
        }

        // Transform the point using the accumulated transformation matrix
        return point.matrixTransform(ctm);
      }
}